import React from 'react';
import LocationTemplate from './LocationTemplate';

const FaisonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Faison"
      stateName="North Carolina"
      countyName="Duplin"
      zipCodes={["28341"]}
      latitude={35.1151}
      longitude={-78.1347}
      population={833}
      historicalFact="Founded in 1899, named after Henry Clay Faison, a railroad developer and businessman."
      nearbyTowns={[
        "Warsaw, NC",
        "Mount Olive, NC",
        "Calypso, NC",
        "Turkey, NC",
        "Kenansville, NC",
        "Rose Hill, NC",
        "Clinton, NC",
        "Pink Hill, NC"
      ]}
    />
  );
};

export default FaisonPage;